import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'


export const Container = styled.div`
	${row({medium:true})}
	padding-bottom: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-bottom: ${unit(8)};
	}

	${mediaQuery[SIZE.large]}{
		padding-bottom: ${spacer(2)};
	}
`

export const Label = styled.p`
	${props => column({medium:{span:6,before:3,after:3}},{direction:props.theme.direction})}
	${typeLabel01}
	color: ${props => props.theme.alternative};
	margin-bottom: ${unit(3)};
	text-align: center;
`

export const Heading = styled.div`
	${props => column({medium:{span:6,before:3,after:3}},{direction:props.theme.direction})}
	${typeHeading02}
	color: ${props => props.theme.foreground};
	text-align: center;
`